<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="fou-email-send-modal-root">
    <Modal
      v-if="isOpen"
      showButtons="confirmandcancel"
      :confirmButtonLabel="confirmButtonLabel"
      :disableConfirmButton="remainingTime > 0"
      @update:bundlepopupconfirm="onConfirm"
      @update:bundlepopup="onClose"
    >
      <!-- Email Verification Modal Title -->
      <template #title>
        <MdTypography     
          tag="h1"
          textalign="start"
          color="spirits--900"
          variant="heading5--medium"
        >
          {{ $t('components.general.verify_email.modal.title') }}
        </MdTypography>
      </template>
      <template #content>
        <!-- Email Verification Modal Description -->
        <div 
          id="email-verification-modal-description-primary"
          data-qa-id="email-verification-modal-description-primary"
        >
          <MdTypography
            tag="p"
            textalign="start"
            color="spirits--700"
            variant="body1--regular"
          >
            {{ $t('components.general.verify_email.modal.content_primary') }}
          </MdTypography>
        </div>
        <br>
        <!-- Email Verification Modal Description with timer -->
        <div
          id="email-verification-modal-description-secondary"
          data-qa-id="email-verification-modal-description-secondary"
        >
          <MdTypography
            tag="p"
            textalign="start"
            color="spirits--700"
            variant="body1--regular"
          >
            <span v-html="secondaryDescription" />
          </MdTypography>
        </div>
      </template>
    </Modal>
  </div>
</template>
    
<script src="./script.js"></script>
<style lang="scss" src="./stylesheet/index.scss" />
